import type { SVGProps } from 'react'

export const LineHelpCircle = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M11.745 14.589h-.006a.75.75 0 0 1-.744-.757l.004-.375q0-.032.003-.064c.104-1.091.828-1.76 1.41-2.297.198-.182.384-.354.543-.534.194-.219.476-.666.18-1.207-.341-.624-1.174-.8-1.82-.652-.676.154-.925.731-1.014 1.061a.75.75 0 0 1-1.45-.388c.3-1.116 1.075-1.894 2.128-2.135 1.417-.324 2.845.249 3.471 1.394.522.954.379 2.074-.373 2.922a9 9 0 0 1-.648.64c-.538.498-.874.83-.931 1.31l-.003.338a.75.75 0 0 1-.75.744m0 2.249a.746.746 0 0 1-.529-1.279.776.776 0 0 1 1.058 0 .74.74 0 0 1 .221.528c0 .2-.079.39-.217.533a.77.77 0 0 1-.533.217"
			fill="currentColor"
		/>
		<path
			d="M12.018 2.363a9.64 9.64 0 0 1 4.29 1.004c3.243 1.622 5.338 5.013 5.338 8.636a9.72 9.72 0 0 1-3.731 7.623 9.72 9.72 0 0 1-8.431 1.696c-3.475-.935-6.198-3.814-6.934-7.335A9.73 9.73 0 0 1 6.08 4.38a9.7 9.7 0 0 1 5.94-2.017Zm0 1.301c-1.87 0-3.696.618-5.142 1.742a8.41 8.41 0 0 0-3.052 8.315 8.4 8.4 0 0 0 5.998 6.345 8.42 8.42 0 0 0 7.295-1.467 8.41 8.41 0 0 0 3.23-6.596c0-3.136-1.813-6.069-4.62-7.473a8.3 8.3 0 0 0-3.709-.866Z"
			fill="currentColor"
			stroke="#fff"
			strokeWidth={0.2}
		/>
	</svg>
)
